import { useCallback } from 'react';
import { useChartContext } from '@shopify/polaris-viz-core';

function useBarChartTooltipContent({
  data,
  renderTooltipContent,
  seriesColors
}) {
  const {
    theme
  } = useChartContext();
  return useCallback(activeIndex => {
    if (activeIndex === -1) {
      return null;
    }

    const tooltipData = [{
      shape: 'Bar',
      data: []
    }];
    data.forEach(({
      name,
      data: seriesData,
      color
    }, index) => {
      const {
        value
      } = seriesData[activeIndex];
      tooltipData[0].data.push({
        key: `${name}`,
        value,
        color: color !== null && color !== void 0 ? color : seriesColors[index]
      });
    });
    return renderTooltipContent({
      data: tooltipData,
      activeIndex,
      title: `${data[0].data[activeIndex].key}`,
      dataSeries: data,
      theme
    });
  }, [data, seriesColors, theme, renderTooltipContent]);
}

export { useBarChartTooltipContent };
